import React from "react";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { withRouter } from "react-router-dom";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import axios from "axios";
import API from "../helpers/api";
import { toast } from "react-toastify";
import { getStaffList } from "../Actions/StaffManagementAPI";
import { normalizeShipStaffRecord } from "../helpers/shipStaffNormalize";
import "./UserManagementMaster.css";

const currentUser = JSON.parse(localStorage.getItem("currentUser"));

const defaultSearchData = {
  Name: "",
  PageNumber: 1,
  PageSize: 15,
};

class StaffManagementDetail extends React.Component {
  componentDidUpdate(prevProps) {
    const { match, StaffDetails, dispatch } = this.props;
    if (match.params.id !== prevProps.match.params.id && StaffDetails) {
      dispatch({ type: "StaffDetails", data: normalizeShipStaffRecord(StaffDetails) });
    }

    window.onpopstate = () => {
      this.props.dispatch({ type: "ShowSidePan", data: false });
      this.props.history.push("/Home/Management/Staff");
    };
  }

  hideSidePanel = () => {
    this.props.dispatch({ type: "ShowSidePan", data: false });
    this.props.history.push("/Home/Management/Staff");
  };

  EditStaffDetails() {
    const { history, dispatch, StaffDetails } = this.props;
    dispatch({ type: "StaffDetails", data: normalizeShipStaffRecord(StaffDetails) });
    dispatch({ type: "ShowSidePan", data: false });
    history.push(`/Home/Management/Staff/Edit/${StaffDetails.shipStaffId}`);
    window.scrollTo(0, 0);
  }

  deleteStaffDetails() {
    const { t, StaffDetails, history, dispatch } = this.props;
    const staff = normalizeShipStaffRecord(StaffDetails);

    confirmAlert({
      message: `${t("confirmAlertMessage.DeleteMsg")}`,
      buttons: [
        {
          label: `${t("confirmAlertMessage.Yes")}`,
          onClick: () => {
            const payload = {
              shipStaffId: staff.shipStaffId,
              name: staff.name,
              phone: staff.phone,
              email: staff.email,
              address: staff.address || "",
              isDeleted: true,
              modifiedBy: currentUser?.name || "",
              modifiedDate: "",
            };

            axios
              .put(API.putShipStaff, payload, {
                headers: { key: currentUser.accessToken },
              })
              .then(() => {
                dispatch(getStaffList(defaultSearchData));
                dispatch({ type: "ShowSidePan", data: false });
                history.push("/Home/Management/Staff");
                toast.success(t("CommonText.CommonDelete"));
              })
              .catch(() => {
                toast.error(t("CommonText.500ErrorMessage"));
              });
          },
        },
        {
          label: `${t("confirmAlertMessage.No")}`,
        },
      ],
    });
  }

  renderDetailField(label, value, iconClass, fullWidth = false) {
    return (
      <div className={`um-detail-field${fullWidth ? " um-detail-field-full" : ""}`}>
        <span className="um-field-label um-list-label">
          <i className={`fa ${iconClass} um-list-label-icon`} aria-hidden="true"></i>
          <span>{label}</span>
        </span>
        <div className="um-detail-value">{value || "-"}</div>
      </div>
    );
  }

  render() {
    const { StaffDetails, t } = this.props;
    const staff = normalizeShipStaffRecord(
      StaffDetails && typeof StaffDetails === "object" ? StaffDetails : {}
    );

    return (
      <div className="full-height user-module-master um-sidepane-detail">
        <div className="um-sidepane-detail-inner">
          <button
            type="button"
            className="btn btn-primary text-uppercase txtside-btn txtht-btn blue um-return-btn"
            onClick={this.hideSidePanel}
          >
            <span>&larr;</span>
            {t("CommonText.Return")}
          </button>

          <div className="um-section">
            <div className="um-section-header">
              <h5 className="um-section-title">
                <i className="fa fa-eye um-section-title-icon" aria-hidden="true"></i>
                {t("StaffManagementScreenContent.ViewDetails")}
              </h5>
            </div>
            <div className="um-section-body">
              <div className="um-detail-grid">
                {this.renderDetailField(
                  t("EquipmentManagementScreenContent.Name"),
                  staff.name,
                  "fa-user"
                )}
                {this.renderDetailField(
                  t("ServicedByScreenContent.Email"),
                  staff.email,
                  "fa-envelope-o"
                )}
                {this.renderDetailField(
                  t("ClientManagementScreenContent.Phone"),
                  staff.phone,
                  "fa-phone"
                )}
                {this.renderDetailField(
                  t("ClientManagementScreenContent.Address"),
                  staff.address,
                  "fa-map-marker"
                )}
                {this.renderDetailField(
                  t("content.Shipname"),
                  staff.shipName,
                  "fa-ship",
                  true
                )}
              </div>
            </div>
          </div>

          <div className="um-form-actions um-sidepane-actions">
            <button
              type="button"
              className="btn btn-primary text-uppercase um-btn um-btn-primary"
              onClick={() => this.EditStaffDetails()}
            >
              {t("IntervelScreen.Edit")}
            </button>
            <button
              type="button"
              className="btn btn-light text-uppercase um-btn um-btn-secondary"
              onClick={() => this.deleteStaffDetails()}
            >
              {t("CommonText.Delete")}
            </button>
          </div>
        </div>
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

function mapStateToProps(state) {
  return {
    StaffDetails: state.MasterScreenReducer.StaffDetails,
  };
}

export default withTranslation()(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(StaffManagementDetail))
);
